export type SupportedLocale = 'ja' | 'en' | 'zh-TW' | 'zh-CN' | 'ko';

export interface LocaleOption {
  code: SupportedLocale;
  name: string;
  flag: string;
}

export const SUPPORTED_LOCALES: LocaleOption[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
  { code: 'zh-CN', name: '简体中文', flag: '🇨🇳' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
];

export interface TranslationSchema {
  // アプリ基本情報
  app: {
    title: string;
    subtitle: string;
    privacyBadge: string;
  };
  // シミュレーターバー
  sim: {
    label: string;
    webFree: string;
    pcPaid: string;
    mobilePaid: string;
  };
  // ヘッダー
  header: {
    openFile: string;
    openUrl: string;
    openUrlLocked: string;
    presets: string;
    export: string;
    exportLocked: string;
    share: string;
    togglePanel: string;
    mobileOpen: string;
    mobileClose: string;
    langSelect: string;
    proBadge: string;
    getProBtn: string;
  };
  // キャンバス領域
  canvas: {
    hint: string;
    sampleLabel: string;
    dropOverlay: string;
    watermark: string;
    pinTitle: string;
    samplePudding: string;
    samplePeach: string;
    sampleCherry: string;
    sampleNikukyu?: string;
    sampleGirl?: string;
    guideLink?: string;
  };
  // 物理調整タブ
  physics: {
    tabTitle: string;
    radius: string;
    stiffness: string;
    damping: string;
    touchRing: string;
    poke: string;
    reset: string;
    savePreset: string;
    savePresetLocked: string;
  };
  // 自動揺れタブ
  wobble: {
    tabTitle: string;
    enable: string;
    mode: string;
    breath: string;
    heartbeat: string;
    tremble: string;
    speed: string;
    intensity: string;
    radius: string;
    origin: string;
    showGuide: string;
    hideGuide: string;
    pickPos: string;
    pickingPos: string;
    resetCenter: string;
    centerLabel: string;
    guideNote: string;
  };
  // オーディオタブ
  audio: {
    tabTitle: string;
    masterVolume: string;
    seSelect: string;
    sePurin: string;
    sePoyon: string;
    seWater: string;
    mute: string;
  };
  // URL取り込みモーダル
  urlModal: {
    title: string;
    desc: string;
    proNote: string;
    inputLabel: string;
    placeholder: string;
    samplesTitle: string;
    sampleCat: string;
    sampleSweet: string;
    sampleSakura: string;
    note: string;
    submit: string;
    loading: string;
    cancel: string;
    errEmpty: string;
    errInvalid: string;
    errFailed: string;
    tipPaste?: string;
  };
  // エクスポートモーダル
  export: {
    title: string;
    format: string;
    fmtGif: string;
    fmtMp4: string;
    fmtWebm: string;
    duration: string;
    start: string;
    recording: string;
    processing: string;
    watermarkNotice: string;
    cancel: string;
    freeNotice?: string;
    proNotice?: string;
    viewProBtn?: string;
    completeTitle?: string;
    completeSaved?: string;
    shareToX?: string;
    copyShareText?: string;
    copiedText?: string;
    downloadAgain?: string;
    tipXShare?: string;
    proUpsellTitle?: string;
    proUpsellDesc?: string;
    newExport?: string;
    close?: string;
    recTimer?: string;
    touchHint?: string;
  };
  // プリセットモーダル
  preset: {
    saveTitle: string;
    manageTitle: string;
    nameLabel: string;
    saveBtn: string;
    applyBtn: string;
    deleteBtn: string;
    cancelBtn: string;
    defaultName: string;
    maxLimitNotice: string;
  };
  // アップグレードモーダル
  upgrade: {
    title: string;
    heading: string;
    perkUrl: string;
    perkPreset: string;
    perkExport: string;
    perkAudio: string;
    perkWobble: string;
    hint: string;
    ok: string;
    buyBtn: string;
    saleBadge: string;
    haveKey: string;
    keyPlaceholder: string;
    activateBtn: string;
    activating: string;
    successMsg: string;
    deactivateBtn: string;
    deactivatedMsg: string;
    activeStatus: string;
    errInvalid: string;
    errMaxUses: string;
    errNetwork: string;
    errRefunded: string;
    closeBtn: string;
  };
  // 広告バナー
  ad: {
    sponsored: string;
    houseAdText: string;
    removeAdsBtn: string;
  };
  // SNS・X(Twitter)シェア
  share: {
    btnLabel: string;
    modalTitle: string;
    modalDesc: string;
    tweetText: string;
    hashtags: string;
    postBtn: string;
    copyBtn: string;
    copiedNotice: string;
    exportSuccessTitle: string;
    exportSuccessDesc: string;
    closeBtn: string;
  };
  // 法的表記・お問い合わせ
  legal: {
    privacyTitle: string;
    termsTitle: string;
    contactTitle: string;
    footerPrivacy: string;
    footerTerms: string;
    footerContact: string;
    contactDesc: string;
    xAccount: string;
    closeBtn: string;
    openFullPrivacy?: string;
    openFullTerms?: string;
    privacyBanner?: string;
    privacySec1Title?: string;
    privacySec1Desc?: string;
    privacySec2Title?: string;
    privacySec2Desc?: string;
    termsSec1Title?: string;
    termsSec1Desc?: string;
    termsSec2Title?: string;
    termsSec2Desc?: string;
    termsSec3Title?: string;
    termsSec3Desc?: string;
    contactButton?: string;
    operatorLabel?: string;
  };
}
